import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LegalNoticesService, LegalNotice } from '../../../services/legal-notices.service';
import { BreadcrumbComponent, BreadcrumbItem } from '../../common/breadcrumb/breadcrumb.component';

@Component({
  selector: 'app-ganadores',
  standalone: true,
  imports: [CommonModule, BreadcrumbComponent],
  templateUrl: './ganadores.component.html',
  styleUrl: './ganadores.component.scss'
})
export class GanadoresComponent implements OnInit {
  legalNotices: LegalNotice[] = [];
  filteredNotices: LegalNotice[] = [];
  tipos: string[] = [];
  selectedTipo: string = '';
  isLoading: boolean = true;
  error: string = '';

  breadcrumbItems: BreadcrumbItem[] = [
    { label: 'Inicio', url: '/' },
    { label: 'Ganadores y Sorteos' }
  ];

  constructor(private readonly legalNoticesService: LegalNoticesService) {}

  ngOnInit(): void {
    this.loadGanadores();
  }

  loadGanadores(): void {
    this.isLoading = true;
    // Usar la URL específica para ganadores
    this.legalNoticesService.getGanadores().subscribe({
      next: (data) => {
        this.legalNotices = data.filter(notice => notice.estado).sort((a, b) => b.orden - a.orden);
        this.tipos = [...new Set(this.legalNotices.map(notice => notice.tipo))];
        // Por defecto seleccionar "Ganadores Clientes"
        this.filterByTipo('Ganadores Clientes');
        this.isLoading = false;
      },
      error: (error) => {
        // Para desarrollo, mostrar datos de ejemplo si la API no está disponible
        console.warn('API no disponible, usando datos de ejemplo:', error);
        this.loadMockData();
        this.isLoading = false;
      }
    });
  }

  // Datos de ejemplo para desarrollo
  private loadMockData(): void {
    const mockData: LegalNotice[] = [
      {
        id: 1,
        nombre: "Ganadores Sorteo Marzo 2025 - Unimarc",
        url: "https://unipay.cl/api/descargaArchivo/Ganadores_Sorteo_Marzo_2025_Unimarc.pdf",
        tipo: "Ganadores Clientes",
        fecha: "2025-03-15",
        estado: true,
        orden: 1
      },
      {
        id: 2,
        nombre: "Ganadores Sorteo Febrero 2025 - Alvi",
        url: "https://unipay.cl/api/descargaArchivo/Ganadores_Sorteo_Febrero_2025_Alvi.pdf",
        tipo: "Ganadores Clientes",
        fecha: "2025-02-28",
        estado: true,
        orden: 2
      },
      {
        id: 3,
        nombre: "Ganadores Sorteo Enero 2025 - Mayorista 10",
        url: "https://unipay.cl/api/descargaArchivo/Ganadores_Sorteo_Enero_2025_M10.pdf",
        tipo: "Ganadores Clientes",
        fecha: "2025-01-31",
        estado: true,
        orden: 3
      },
      {
        id: 4,
        nombre: "Ganadores Sorteo Especial Navidad 2024",
        url: "https://unipay.cl/api/descargaArchivo/Ganadores_Sorteo_Navidad_2024.pdf",
        tipo: "Ganadores Otros",
        fecha: "2024-12-25",
        estado: true,
        orden: 4
      },
      {
        id: 5,
        nombre: "Ganadores Sorteo Black Friday 2024",
        url: "https://unipay.cl/api/descargaArchivo/Ganadores_Sorteo_BlackFriday_2024.pdf",
        tipo: "Ganadores Otros",
        fecha: "2024-11-29",
        estado: true,
        orden: 5
      }
    ];

    this.legalNotices = mockData;
    this.tipos = ["Ganadores Clientes", "Ganadores Otros"];
    // Por defecto seleccionar "Ganadores Clientes"
    this.filterByTipo('Ganadores Clientes');
  }

  filterByTipo(tipo: string): void {
    this.selectedTipo = tipo;
    if (tipo === '') {
      this.filteredNotices = []; // No mostrar nada si no se selecciona un tipo
    } else {
      this.filteredNotices = this.legalNotices.filter(notice => notice.tipo === tipo);
    }
  }

  downloadDocument(url: string): void {
    this.legalNoticesService.downloadDocument(url);
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleDateString('es-CL', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }
}
